// extracted by mini-css-extract-plugin
export default {"section-4-grid":"Section4_section-4-grid__vWk7v","section-4-emphasis":"Section4_section-4-emphasis__EcODu","section-4-conclusion":"Section4_section-4-conclusion__NFijW"};